import { format, isValid, parseISO } from 'date-fns';
import { Dayjs } from "dayjs";
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { constantsPermission } from '../../../../Config/Constants';
import { customStyles } from '../../../../core/common/Custom Style/CustomStyle';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { useGetPermitZoningQuery, useLazyGetUrlByMunicipalityQuery, useUpsertPermitZoningMutation } from '../../../../services/EndPointsApis';
import Select, { StylesConfig } from "react-select";


const PermitZoningTab = ({ projectId, projectLookups, showHistory, storeProjectId }: any) => {
    //PermissionHook
    const { view: viewPermitZonning, edit: editPermitZonning, create: createPermitZonning } = usePermission(constantsPermission?.moduleId?.permitZoning);
    const [isEditing, setisEditing] = useState(false)

    //municipality api
    const [triggerMunicipalityUrl, { data: municipalityUrl, isSuccess: isSuccessUrl }] = useLazyGetUrlByMunicipalityQuery()

    //Upsert Api
    const [UpsertPermitZoning, { data, isError, error, isSuccess, isLoading }] = useUpsertPermitZoningMutation();

    //Get Api
    const { data: permitZoneData, refetch, isLoading: isLoadingScope } = useGetPermitZoningQuery({ Id: projectId });
    //formik   

    const initialValuesPermitZoning = {
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        municipality: "",
        internalURL: "",
        externalURL: "",
        createdBy: 0,
        modifiedBy: 0,
        createdDT: "2025-01-20T15:17:26.405Z",
        modifiedDT: "2025-01-20T15:17:26.405Z",
        survey: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2025-01-20T15:17:26.405Z",
                modifiedDT: "2025-01-20T15:17:26.405Z"
            }
        ],
        timeDelays: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2025-01-20T15:17:26.405Z",
                modifiedDT: "2025-01-20T15:17:26.405Z"
            }
        ],
        variations: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2025-01-20T15:17:26.405Z",
                modifiedDT: "2025-01-20T15:17:26.405Z"
            }
        ],
        additionalMeetings: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2025-01-20T15:17:26.405Z",
                modifiedDT: "2025-01-20T15:17:26.405Z"
            }
        ],
        permitReviewProcess: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2025-01-20T15:17:26.405Z",
                modifiedDT: "2025-01-20T15:17:26.405Z"
            }
        ],
        approvedPermitInformation: [
            {
                projectId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                surveyMasterId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                name: "",
                surveyResultRevised: "",
                surveyResultOriginal: "",
                fieldType: "",
                sectionId: 0,
                subSectionId: 0,
                lst_CreatedBy: {
                    id: 0,
                    value: ""
                },
                lst_ModifiedBy: {
                    id: 0,
                    value: ""
                },
                createdDT: "2025-01-20T15:17:26.405Z",
                modifiedDT: "2025-01-20T15:17:26.405Z"
            }
        ]
    }

    const formik = useFormik({
        initialValues: initialValuesPermitZoning,
        onSubmit: (values) => {
            UpsertPermitZoning({ ...values })
        },

    });

    useEffect(() => {

        if (isSuccess) {
            toast.success(data?.message);
            refetch()
            setisEditing(false);

        }
        if (isError) {
            toast.success(data?.message);
        }
    }, [isSuccess, isError]);

    useEffect(() => {
        refetch()
    }, []);

    useEffect(() => {
        if (permitZoneData?.result && Object.keys(permitZoneData?.result).length > 0) {
            formik.setValues({ ...permitZoneData?.result });
            // setDisabledata(true)
        } else {
            // setUpdateId(0);
        }
    }, [permitZoneData]);

    const handleStartDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('scheduledDate', date ? date.format('YYYY-MM-DD') : null);
        formik.setFieldTouched('scheduledDate', true, false);
    };


    const handleSavePermitZoning = () => {
        formik.handleSubmit();
    }

    const handleEditPermitZoning = () => {
        setisEditing(true);
    }

    // useEffect(() => {
    //     if (formik.values.municipality !== '' && !formik.values.municipality === null) {
    //         triggerMunicipalityUrl({ Municipality: formik?.values?.municipality })
    //     }
    // }, [formik.values.municipality])

    useEffect(() => {
        if (municipalityUrl?.result) {
            formik.setFieldValue('externalURL', municipalityUrl.result.externalURL || '');
            formik.setFieldValue('internalURL', municipalityUrl.result.internalURL || '');
        }
    }, [municipalityUrl]);

    return (
        <>
            <div className='row'>
                <div className='col-md-12'>
                    {!isEditing ?
                        <Ribbon
                            //item?.={items}
                            buttonText={"Edit"}
                            onClickbtn={handleEditPermitZoning}
                            buttonClass="add-popup ribbon-btn"
                            disabled={!editPermitZonning}
                        />
                        :
                        <Ribbon
                            //item?.={items}
                            buttonText={isLoading ? "Loading..." : "Save"}
                            onClickbtn={handleSavePermitZoning}
                            buttonClass="add-popup ribbon-btn"
                        />
                    }

                </div>
            </div>
            <div className='row mt-3' style={{ maxHeight: '60vh', overflow: 'auto' }}>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <div className='row '>
                                <div className='col-md-12'>
                                    <label className="input-label">
                                        Municipality
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={projectLookups?.result?.Municipality?.
                                            map((option: any) => ({
                                                label: option?.value,
                                                value: option?.id
                                            }))}
                                        value={
                                            formik.values?.municipality
                                                ? {
                                                    value: formik.values?.municipality,
                                                    label: formik.values?.municipality || '',
                                                }
                                                : null
                                        }
                                        onChange={(selectedOption: any) => {
                                            formik.setFieldValue(`municipality`, selectedOption.label);
                                            triggerMunicipalityUrl({ Municipality: selectedOption.label })
                                        }}
                                        isDisabled={!isEditing}
                                    />
                                </div>
                                <div className='col-md-12 mt-2'>
                                    <label className='w-50'>External URL</label>
                                    <input
                                        type="text"
                                        className='form-control'
                                        // disabled={isReadOnly}
                                        {...formik.getFieldProps('externalURL')}
                                        disabled={!isEditing}
                                    />
                                </div>
                                <div className='col-md-12 mt-2'>
                                    <label className='w-50'>Internal URL</label>
                                    <input
                                        type="text"
                                        className='form-control'
                                        disabled={!isEditing}
                                        {...formik.getFieldProps('internalURL')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-3'>Approved Permit Information:</h5>
                            <div className='row '>
                                {formik.values.approvedPermitInformation?.map((item, index) => {
                                    const transformNameToKey = (name: string) => {
                                        return name
                                            .replace(/[\s()/]/g, "_")
                                            .replace(/_+/g, "_")
                                    };
                                    const originalIndex = formik.values.approvedPermitInformation.findIndex(i => i.surveyMasterId === item?.surveyMasterId);
                                    return (
                                        <div key={index} className='mb-2'>
                                            {item?.fieldType === "OptionSingle" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <label className="checkboxs mt-1">
                                                        <input
                                                            type="checkbox"
                                                            checked={item?.surveyResultOriginal === '1'}
                                                            disabled={!isEditing}
                                                            onChange={() => {
                                                                const newValue = item?.surveyResultOriginal === '1' ? '0' : '1';
                                                                formik.setFieldValue(`approvedPermitInformation[${index}].surveyResultOriginal`, newValue);
                                                            }}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </>
                                            ) : item?.fieldType === "DD" ? (
                                                <>
                                                    <div>
                                                        <label className="input-label">
                                                            {item?.name}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={projectLookups?.result?.[transformNameToKey(item?.name)]?.
                                                                map((option: any) => ({
                                                                    label: option?.value,
                                                                    value: option?.id
                                                                }))}
                                                            value={
                                                                formik.values?.approvedPermitInformation[index].surveyResultOriginal
                                                                    ? {
                                                                        value: formik.values?.approvedPermitInformation[index].surveyResultOriginal,
                                                                        label: formik.values?.approvedPermitInformation[index].surveyResultOriginal || '',
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue(`approvedPermitInformation[${index}].surveyResultOriginal`, selectedOption.label);
                                                            }}
                                                            isDisabled={!isEditing}
                                                        />
                                                    </div>

                                                </>
                                            ) : item?.fieldType === "TextLong" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <textarea
                                                            rows={3}
                                                            className='form-control '
                                                            disabled={!isEditing}
                                                            {...formik.getFieldProps(`approvedPermitInformation[${index}].surveyResultOriginal`)}
                                                        />
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "Date" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <div className="form-wrap mb-0 icon-form">
                                                            <span className="form-icon">
                                                                <i className="ti ti-calendar-check" />
                                                            </span>
                                                            <DatePicker
                                                                className="form-control datetimepicker deals-details"
                                                                selected={
                                                                    item?.surveyResultOriginal && isValid(parseISO(item.surveyResultOriginal))
                                                                        ? parseISO(item.surveyResultOriginal)
                                                                        : null
                                                                }
                                                                onChange={(date: Date | null) => {
                                                                    const formattedDate = date ? format(date, 'yyyy-MM-dd') : '';
                                                                    formik.setFieldValue(`approvedPermitInformation[${index}].surveyResultOriginal`, formattedDate);
                                                                }}
                                                                dateFormat="MMM-dd-yyyy"
                                                                disabled={!isEditing}

                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ) :
                                                (
                                                    <>
                                                        <label className='mb-0'>{item?.name}</label>
                                                        <div className='d-flex  align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                disabled={!isEditing}
                                                                {...formik.getFieldProps(`approvedPermitInformation[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-3'>Time Delays:</h5>
                            <div className='row '>
                                {formik.values.timeDelays?.map((item, index) => {
                                    const transformNameToKey = (name: string) => {
                                        return name
                                            .replace(/[\s()/]/g, "_")
                                            .replace(/_+/g, "_")
                                    };
                                    const originalIndex = formik.values.timeDelays.findIndex(i => i.surveyMasterId === item?.surveyMasterId);
                                    return (
                                        <div key={index} className=' mb-2'>
                                            <label className='mb-0'>{item?.name}</label>
                                            {item?.fieldType === "OptionSingle" ? (
                                                <label className="checkboxs mt-1 mb-2">
                                                    <input
                                                        type="checkbox"
                                                        checked={item?.surveyResultOriginal === '1'}
                                                        disabled={!isEditing}
                                                        onChange={() => {
                                                            const newValue = item?.surveyResultOriginal === '1' ? '0' : '1';
                                                            formik.setFieldValue(`timeDelays[${index}].surveyResultOriginal`, newValue); // Ensure correct index
                                                        }}
                                                    />
                                                    <span className="checkmarks" />
                                                </label>
                                            ) : item?.fieldType === "DD" ? (
                                                <>
                                                    <div>
                                                        <label className="input-label">
                                                            {item?.name}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={projectLookups?.result?.[transformNameToKey(item?.name)]?.
                                                                map((option: any) => ({
                                                                    label: option?.value,
                                                                    value: option?.id
                                                                }))}
                                                            value={
                                                                formik.values?.timeDelays[index].surveyResultOriginal
                                                                    ? {
                                                                        value: formik.values?.timeDelays[index].surveyResultOriginal,
                                                                        label: formik.values?.timeDelays[index].surveyResultOriginal || '',
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue(`timeDelays[${index}].surveyResultOriginal`, selectedOption.label);
                                                            }}
                                                            isDisabled={!isEditing}
                                                        />
                                                    </div>

                                                </>
                                            ) : item?.fieldType === "TextLong" ? (
                                                <>
                                                    <div className='w-100'>
                                                        <textarea
                                                            rows={3}
                                                            className='form-control '
                                                            disabled={!isEditing}
                                                            {...formik.getFieldProps(`timeDelays[${index}].surveyResultOriginal`)}
                                                        />
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "Date" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <div className="form-wrap mb-0 icon-form">
                                                            <span className="form-icon">
                                                                <i className="ti ti-calendar-check" />
                                                            </span>
                                                            <DatePicker
                                                                className="form-control datetimepicker deals-details"
                                                                selected={item?.surveyResultOriginal ? parseISO(item?.surveyResultOriginal) : null} // Convert string to Date
                                                                onChange={(date: Date | null) => {
                                                                    const formattedDate = date ? format(date, 'yyyy-MM-dd') : ''; // Format date properly
                                                                    formik.setFieldValue(`timeDelays[${index}].surveyResultOriginal`, formattedDate);
                                                                }}
                                                                dateFormat="MMM-dd-yyyy"
                                                                disabled={!isEditing}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ) :
                                                (
                                                    <div className="d-flex gap-3 w-100 justify-content-end">
                                                        <div className='d-flex gap-2 align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                disabled={!isEditing}
                                                                {...formik.getFieldProps(`timeDelays[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-3'>Survey:</h5>
                            <div className='row '>
                                {formik.values.survey?.map((item, index) => {
                                    const transformNameToKey = (name: string) => {
                                        return name
                                            .replace(/[\s()/]/g, "_")
                                            .replace(/_+/g, "_")
                                    };
                                    const originalIndex = formik.values.survey.findIndex(i => i.surveyMasterId === item?.surveyMasterId);
                                    return (
                                        <div key={index} className='mb-2'>
                                            {item?.fieldType === "OptionSingle" ? (
                                                <>
                                                    <div className='d-flex gap-3'>
                                                        <label className='mb-0'>{item?.name}</label>
                                                        <label className="checkboxs mt-1 mb-3">
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.surveyResultOriginal === '1'}
                                                                disabled={!isEditing}
                                                                onChange={() => {
                                                                    const newValue = item?.surveyResultOriginal === '1' ? '0' : '1';
                                                                    formik.setFieldValue(`survey[${index}].surveyResultOriginal`, newValue);
                                                                }}
                                                            />
                                                            <span className="checkmarks" />
                                                        </label>
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "DD" ? (
                                                <>
                                                    <div>
                                                        <label className="input-label">
                                                            {item?.name}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={projectLookups?.result?.[transformNameToKey(item?.name)]?.
                                                                map((option: any) => ({
                                                                    label: option?.value,
                                                                    value: option?.id
                                                                }))}
                                                            value={
                                                                formik.values?.survey[index]?.surveyResultOriginal
                                                                    ? {
                                                                        value: formik.values?.survey[index]?.surveyResultOriginal,
                                                                        label: formik.values?.survey[index]?.surveyResultOriginal || '',
                                                                    }
                                                                    : null
                                                            }
                                                            isDisabled={!isEditing}
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue(`survey[${index}].surveyResultOriginal`, selectedOption.label);
                                                            }}
                                                        />
                                                    </div>

                                                </>
                                            ) : item?.fieldType === "TextLong" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <textarea
                                                            rows={3}
                                                            className='form-control '
                                                            disabled={!isEditing}
                                                            {...formik.getFieldProps(`survey[${index}].surveyResultOriginal`)}
                                                        />
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "Date" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <div className="form-wrap mb-0 icon-form">
                                                            <span className="form-icon">
                                                                <i className="ti ti-calendar-check" />
                                                            </span>
                                                            <DatePicker
                                                                className="form-control datetimepicker deals-details"
                                                                selected={item?.surveyResultOriginal ? parseISO(item?.surveyResultOriginal) : null} // Convert string to Date
                                                                onChange={(date: Date | null) => {
                                                                    const formattedDate = date ? format(date, 'yyyy-MM-dd') : ''; // Format date properly
                                                                    formik.setFieldValue(`survey[${index}].surveyResultOriginal`, formattedDate);
                                                                }}
                                                                dateFormat="MMM-dd-yyyy"
                                                                disabled={!isEditing}

                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ) :
                                                (
                                                    <>
                                                        <label className='mb-0'>{item?.name}</label>
                                                        <div>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                disabled={!isEditing}
                                                                {...formik.getFieldProps(`survey[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                    </div>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-3'>Variations:</h5>
                            <div className='row '>
                                {formik.values.variations?.map((item, index) => {
                                    const originalIndex = formik.values.variations.findIndex(i => i.surveyMasterId === item?.surveyMasterId);
                                    const transformNameToKey = (name: string) => {
                                        return name
                                            .replace(/[\s()/]/g, "_")
                                            .replace(/_+/g, "_")
                                    };
                                    return (
                                        <div key={index} className='mb-2'>
                                            {item?.fieldType === "OptionSingle" ? (
                                                <>
                                                    <div className='d-flex'>
                                                        <label className='mb-0 w-50'>{item?.name}</label>
                                                        <label className="checkboxs mt-1">
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.surveyResultOriginal === '1'}
                                                                disabled={!isEditing}
                                                                onChange={() => {
                                                                    const newValue = item?.surveyResultOriginal === '1' ? '0' : '1';
                                                                    formik.setFieldValue(`variations[${index}].surveyResultOriginal`, newValue); // Ensure correct index
                                                                }}
                                                            />
                                                            <span className="checkmarks" />
                                                        </label>
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "TextLong" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <textarea
                                                            rows={3}
                                                            className='form-control '
                                                            disabled={!isEditing}
                                                            {...formik.getFieldProps(`variations[${index}].surveyResultOriginal`)}
                                                        />
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "DD" ? (
                                                <>
                                                    <div>
                                                        <label className="input-label">
                                                            {item?.name}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={projectLookups?.result?.[transformNameToKey(item?.name)]?.
                                                                map((option: any) => ({
                                                                    label: option?.value,
                                                                    value: option?.id
                                                                }))}
                                                            value={
                                                                formik.values?.variations[index]?.surveyResultOriginal
                                                                    ? {
                                                                        value: formik.values?.variations[index]?.surveyResultOriginal,
                                                                        label: formik.values?.variations[index]?.surveyResultOriginal || '',
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue(`variations[${index}].surveyResultOriginal`, selectedOption.label);
                                                            }}
                                                            isDisabled={!isEditing}
                                                        />
                                                    </div>

                                                </>
                                            ) : item?.fieldType === "Date" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <div className="form-wrap mb-0 icon-form">
                                                            <span className="form-icon">
                                                                <i className="ti ti-calendar-check" />
                                                            </span>
                                                            <DatePicker
                                                                className="form-control datetimepicker deals-details"
                                                                selected={item?.surveyResultOriginal ? parseISO(item?.surveyResultOriginal) : null} // Convert string to Date
                                                                onChange={(date: Date | null) => {
                                                                    const formattedDate = date ? format(date, 'yyyy-MM-dd') : ''; // Format date properly
                                                                    formik.setFieldValue(`variations[${index}].surveyResultOriginal`, formattedDate);
                                                                }}
                                                                dateFormat="MMM-dd-yyyy"
                                                                disabled={!isEditing}

                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='d-flex align-items-center'>
                                                        <input
                                                            type="text"
                                                            className='form-control'
                                                            disabled={!isEditing}
                                                            {...formik.getFieldProps(`variations[${index}].surveyResultOriginal`)}
                                                        />
                                                    </div>
                                                </>
                                            )
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-3'>Additional Meetings:</h5>
                            <div className='row '>
                                {formik.values.additionalMeetings?.map((item, index) => {
                                    const transformNameToKey = (name: string) => {
                                        return name
                                            .replace(/[\s()/]/g, "_")
                                            .replace(/_+/g, "_")
                                    };
                                    const originalIndex = formik.values.additionalMeetings.findIndex(i => i.surveyMasterId === item?.surveyMasterId);
                                    return (
                                        <div key={index} className=' mb-2'>
                                            {item?.fieldType === "OptionSingle" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <label className="checkboxs mt-1">
                                                        <input
                                                            type="checkbox"
                                                            checked={item?.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                const newValue = item?.surveyResultOriginal === '1' ? '0' : '1';
                                                                formik.setFieldValue(`additionalMeetings[${index}].surveyResultOriginal`, newValue); // Ensure correct index
                                                            }}
                                                            disabled={!isEditing}

                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </>

                                            ) : item?.fieldType === "TextLong" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className=' w-100'>
                                                        <textarea
                                                            rows={3}
                                                            className='form-control '
                                                            disabled={!isEditing}
                                                            {...formik.getFieldProps(`additionalMeetings[${index}].surveyResultOriginal`)}
                                                        />
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "Date" ? (
                                                <>
                                                    <label className='mb-0'>
                                                        {item?.name}
                                                    </label>
                                                    <div className="form-wrap mb-0 icon-form">
                                                        <span className="form-icon">
                                                            <i className="ti ti-calendar-check" />
                                                        </span>
                                                        <DatePicker
                                                            className="form-control datetimepicker deals-details"
                                                            selected={item?.surveyResultOriginal ? parseISO(item?.surveyResultOriginal) : null} // Convert string to Date
                                                            onChange={(date: Date | null) => {
                                                                const formattedDate = date ? format(date, 'yyyy-MM-dd') : ''; // Format date properly
                                                                formik.setFieldValue(`additionalMeetings[${index}].surveyResultOriginal`, formattedDate);
                                                            }}
                                                            dateFormat="MMM-dd-yyyy"
                                                            disabled={!isEditing}
                                                        />
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "DD" ? (
                                                <>
                                                    <div>
                                                        <label className="input-label">
                                                            {item?.name}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={projectLookups?.result?.[transformNameToKey(item?.name)]?.
                                                                map((option: any) => ({
                                                                    label: option?.value,
                                                                    value: option?.id
                                                                }))}
                                                            value={
                                                                formik.values?.additionalMeetings[index].surveyResultOriginal
                                                                    ? {
                                                                        value: formik.values?.additionalMeetings[index].surveyResultOriginal,
                                                                        label: formik.values?.additionalMeetings[index].surveyResultOriginal || '',
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue(`additionalMeetings[${index}].surveyResultOriginal`, selectedOption.label);
                                                            }}
                                                            isDisabled={!isEditing}
                                                        />
                                                    </div>

                                                </>
                                            ) :
                                                (
                                                    <>
                                                        <label className='mb-0'>{item?.name}</label>
                                                        <div className='d-flex align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                disabled={!isEditing}
                                                                {...formik.getFieldProps(`additionalMeetings[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>


                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-3'>Permit Review Process:</h5>
                            <div className='row '>
                                {formik.values.permitReviewProcess?.map((item, index) => {
                                    const originalIndex = formik.values?.permitReviewProcess?.findIndex(i => i.surveyMasterId === item?.surveyMasterId);
                                    const transformNameToKey = (name: string) => {
                                        return name
                                            .replace(/[\s()/]/g, "_")
                                            .replace(/_+/g, "_")
                                    };
                                    return (
                                        <div key={index} className='mb-2'>
                                            {item?.fieldType === "OptionSingle" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <label className="checkboxs mt-1">
                                                        <input
                                                            type="checkbox"
                                                            checked={item?.surveyResultOriginal === '1'}
                                                            onChange={() => {
                                                                const newValue = item?.surveyResultOriginal === '1' ? '0' : '1';
                                                                formik.setFieldValue(`permitReviewProcess[${index}].surveyResultOriginal`, newValue); // Ensure correct index
                                                            }}
                                                            disabled={!isEditing}
                                                        />
                                                        <span className="checkmarks" />
                                                    </label>
                                                </>
                                            ) : item?.fieldType === "TextLong" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className=' w-100'>
                                                        <textarea
                                                            rows={3}
                                                            className='form-control '
                                                            disabled={!isEditing}

                                                            {...formik.getFieldProps(`permitReviewProcess[${index}].surveyResultOriginal`)}
                                                        />
                                                    </div>
                                                </>
                                            ) : item?.fieldType === "DD" ? (
                                                <>
                                                    <div>
                                                        <label className="input-label">
                                                            {item?.name}
                                                        </label>
                                                        <Select
                                                            styles={customStyles}
                                                            className="select"
                                                            options={projectLookups?.result?.[transformNameToKey(item?.name)]?.
                                                                map((option: any) => ({
                                                                    label: option?.value,
                                                                    value: option?.id
                                                                }))}
                                                            value={
                                                                formik.values?.permitReviewProcess[index].surveyResultOriginal
                                                                    ? {
                                                                        value: formik.values?.permitReviewProcess[index].surveyResultOriginal,
                                                                        label: formik.values?.permitReviewProcess[index].surveyResultOriginal || '',
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption: any) => {
                                                                formik.setFieldValue(`permitReviewProcess[${index}].surveyResultOriginal`, selectedOption.label);
                                                            }}
                                                            isDisabled={!isEditing}
                                                        />
                                                    </div>

                                                </>
                                            ) : item?.fieldType === "Date" ? (
                                                <>
                                                    <label className='mb-0'>{item?.name}</label>
                                                    <div className='w-100'>
                                                        <div className="form-wrap mb-0 icon-form">
                                                            <span className="form-icon">
                                                                <i className="ti ti-calendar-check" />
                                                            </span>
                                                            <DatePicker
                                                                className="form-control datetimepicker deals-details"
                                                                selected={item?.surveyResultOriginal ? parseISO(item?.surveyResultOriginal) : null} // Convert string to Date
                                                                onChange={(date: Date | null) => {
                                                                    const formattedDate = date ? format(date, 'yyyy-MM-dd') : ''; // Format date properly
                                                                    formik.setFieldValue(`permitReviewProcess[${index}].surveyResultOriginal`, formattedDate);
                                                                }}
                                                                dateFormat="MMM-dd-yyyy"
                                                                disabled={!isEditing}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            ) :
                                                (
                                                    <>
                                                        <label className='mb-0'>{item?.name}</label>
                                                        <div className='d-flex align-items-center'>
                                                            <input
                                                                type="text"
                                                                className='form-control'
                                                                disabled={!isEditing}
                                                                {...formik.getFieldProps(`permitReviewProcess[${index}].surveyResultOriginal`)}
                                                            />
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* <div className='col-md-12 d-flex justify-content-end '>
                    <div className='mt-2 bg-red text-redd position-fixed bottom-0 px-2 rounded' style={{ right: "0px" }}><i>Created at 11/17/2023 by Ann Marie.01:00:22 PM Last modified at 11/17/2023 01:00:22 PM by Maxx Klein.</i></div>
                </div> */}
        </>
    )
}

export default PermitZoningTab